module.exports = __webpack_public_path__ + "img/Dantam Bridal 19.dc382e4c.jpg";